/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Send_LoadingInputs */

const en_chat_send_loading = /** @type {(inputs: Chat_Send_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending…`)
};

const fr_chat_send_loading = /** @type {(inputs: Chat_Send_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoi…`)
};

const ms_sg2_chat_send_loading = /** @type {(inputs: Chat_Send_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menghantar…`)
};

/**
* | output |
* | --- |
* | "Sending…" |
*
* @param {Chat_Send_LoadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const chat_send_loading = /** @type {((inputs?: Chat_Send_LoadingInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Send_LoadingInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_send_loading(inputs)
	if (locale === "fr") return fr_chat_send_loading(inputs)
	return ms_sg2_chat_send_loading(inputs)
});